export const VCC_READ = "vcc.read";
export const BULK_SERVICES_READ = "bulk-services.read";
export const PORT_ORDERS_READ = "port-orders.read";

export const SEND_EMAILS_READ = "send-emails.read";
export const SUPPORT_TOOLS_READ = "support-tools.read";
export const AUDIT_READ = "audit.read";
export const EMAIL_SUPPORT_READ = "email-support.read";
export const FRAUD_SUPPORT_READ = "fraud-support.read";

export const LICENSES_READ = "licenses.read";
export const LICENSES_DELETE = "licenses.delete";
export const LICENSES_UPDATE = "licenses.update";

export const JOBRUNR_READ = "jobrunr.read";
export const GLOBAL_DIALPLANS_WRITE = "global-dialplans.write";
